<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">点位管理&nbsp;/&nbsp;</div>
        <div class="box-header-right">
          <div>点位类型管理</div>
        </div>
      </div>
    </div>
    <div class="section">
      <div class="biaodan2">
        <div class="biaodan-left">
          <div style="height: 100%;width: 100%;">
            <el-form
              :inline="true"
              label-position="left"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="点位类型名称">
                <el-input
                  v-model="form.typeName"
                  clearable
                  placeholder="请输入点位类型名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="启用状态">
                <el-select
                  filterable
                  placeholder="请选择启用状态"
                  clearable
                  v-model="form.enableStatus"
                >
                  <el-option
                    v-for="item in openFlagOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button @click="onSearch" class="search">查询</el-button>
                <el-button class="reset" @click="onReset">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <div class="table-top-btns">
          <div class="left-btn">
            <div class="select-number">
              当前选中
              <span style="color: #3666EA;">{{
                selectedIdOptions.length
              }}</span>
              条
            </div>
            <el-button
              @click="delPointTypeFun(selectedIdOptions, true)"
              icon="el-icon-delete"
              class="delbtn"
              type="text"
              >批量删除</el-button
            >
          </div>
          <div class="right-btn">
            <!-- <el-button class="other el-icon-download" @click="downloadFileFun"
              >模板下载</el-button
            >
            <el-upload
              class="upload-demo"
              accept=".xlsx"
              action="#"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="importDataFun"
            >
              <el-button class="other el-icon-upload2">数据导入</el-button>
            </el-upload> -->

            <el-button @click="addDialogFun({})" class="search el-icon-plus"
              >新增</el-button
            >
          </div>
        </div>
        <common-table
          :select="true"
          :page="page"
          :dataList="dataList"
          :selectedIdOptions="selectedIdOptions"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
          @handleSelectionChange="handleSelectionChange"
          @selectAll="selectAll"
        >
          <template v-slot:enableStatus="{ scope }">
            <el-switch
              @change="
                value => {
                  updatePointTypeFun(value, scope.row);
                }
              "
              v-model="scope.row.enableStatus"
              :active-value="0"
              :inactive-value="1"
              active-color="#0495FF"
            >
            </el-switch>
          </template>
          <template v-slot:operation="{ scope }">
            <el-button
              @click="addDialogFun(scope.row)"
              style="color: #0090FF;font-size: 16px;"
              type="text"
              >编辑</el-button
            >
            <el-button
              @click="delPointTypeFun([scope.row.id])"
              style="color: #EB3538;font-size: 16px;"
              type="text"
              >删除</el-button
            >
          </template>
        </common-table>
      </div>
    </div>
    <addDialog
      v-if="dialogVisible"
      @refreshList="getPointTypeListPageFun"
      :dialogVisible.sync="dialogVisible"
      :curItem="curItem"
    >
    </addDialog>
  </div>
</template>
<script>
import {
  getPointTypeListPage,
  updatePointType,
  delPointType
} from "@/api/point.js";
import { downloadFile } from "@/api/systemManagement.js";
import addDialog from "./components/addDialog.vue";
import commonTable from "@/components/table/index.vue";
import pageChangeSelect from "@/mixins/page-change-select.js";
export default {
  components: {
    addDialog,
    commonTable
  },
  mixins: [pageChangeSelect],
  data() {
    return {
      form: {
        typeName: "",
        enableStatus: null
      },
      openFlagOptions: [
        {
          label: "启用",
          value: 0
        },
        {
          label: "关闭",
          value: 1
        }
      ],
      dialogVisible: false,
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "typeName",
            label: "点位类型名称"
          },
          {
            prop: "createUsername",
            label: "创建人"
          },
          {
            prop: "createTime",
            label: "创建时间"
          },
          {
            prop: "updateTime",
            label: "更新时间"
          },
          {
            slot: "enableStatus",
            label: "是否启用"
          },
          {
            slot: "operation",
            label: "操作"
          }
        ]
      },
      curItem: {}
    };
  },
  mounted() {
    this.getPointTypeListPageFun();
  },
  methods: {
    addDialogFun(item) {
      this.dialogVisible = true;
      this.curItem = item;
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.selectedIdOptions = [];
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.selectedIdOptions = [];
      this.form.typeName = "";
      this.form.enableStatus = null;
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    // 开启关闭
    async updatePointTypeFun(value, item) {
      let params = {
        enableStatus: value,
        typeName: item.typeName,
        id: item.id
      };
      const res = await updatePointType(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.getPointTypeListPageFun();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 删除
    async delPointTypeFun(delList, flag) {
      let params = {
        delList: delList
      };
      const res = await delPointType(params);
      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        if (flag) this.selectedIdOptions = [];
        this.onSearch();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    },
    // 模板下载
    async downloadFileFun() {
      const res = await downloadFile({
        filePath: "/templates/部门事项导入模板.xlsx"
      });
      let fileReader = new FileReader();
      fileReader.onload = function() {
        try {
          if (res.code == 300) {
            // 说明是普通对象数据，后台转换失败
            // proxy.MSG.error(res.message);
            return;
          } else {
            // 解析成对象失败，说明是正常的文件流
            let url = window.URL.createObjectURL(new Blob([res.data]));
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.target = "_blank";
            link.setAttribute("download", "部门事项导入模板.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          }
        } catch (err) {
          console.log(err);
        }
      };
      fileReader.readAsText(res.data);
    },
    // 数据导入
    async importDataFun(file) {
      if (!file.name.endsWith(".xlsx")) {
        this.$message({
          message: "请上传正确格式文件，支持文件类型：.xlsx",
          type: "warning"
        });
        return;
      }
      let formData = new FormData();
      formData.append("file", file.raw);
      const res = await importData(formData);
      if (res.data.code == 200) {
        this.$message({
          message: "导入成功",
          type: "success"
        });
        this.onSearch();
      } else {
        this.$message({
          message: `${res.data.msg}`,
          type: "warning"
        });
      }
    },
    // 分页查询
    async getPointTypeListPageFun() {
      let params = {
        typeName: this.form.typeName,
        enableStatus: this.form.enableStatus,
        page: this.page.page,
        size: this.page.size
      };
      const res = await getPointTypeListPage(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data.records
          ? res.data.data.records
          : [];
        this.page.total = res.data.data.total;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/point/pointType/index.vue